import React, { useState } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { BottomBarProvider, TableContext } from "@swiggy-private/portal-dineout-context";
import { ErrorComponent } from "@swiggy-private/portal-dineout-ui";
import { Toast } from "components/Toast";
import { useLiveNotificationHandler } from "hooks/useLiveNotificationHandler";
import { useTableConfig } from "hooks/useTableConfig";
import { useRouter } from "next/compat/router";
import BottomBar from "../components/BottomBar";

// Lives under TableContext.Provider so the hook has access to tableId /
// restaurantId / parentOrderId when responding to Live Notification CTAs.
const LiveNotificationsMount: React.FC = () => {
    useLiveNotificationHandler();
    return null;
};

const QrLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const router = useRouter();
    const { tableConfig, isLoading, updateParentOrderId } = useTableConfig();
    const [verifyPinFlow, setVerifyPinFlow] = useState<boolean>(false);
    const [, setHasBottomBar] = useState<boolean>(true);
    const isCurtainRaiserShown = true;

    if (!router?.isReady || isLoading) {
        return <></>;
    }

    if (isEmpty(tableConfig.tableId) || isEmpty(tableConfig.restaurantId)) {
        return (
            <ErrorComponent
                onCtaClick={() => {}}
                showCta={false}
                heading={"Your session is not active"}
                description={"Please scan again to continue"}
                showFullPage={true}
            />
        );
    }

    return (
        <>
            <BottomBarProvider>
                <TableContext.Provider value={{ ...tableConfig, verifyPinFlow, setVerifyPinFlow, updateParentOrderId }}>
                    <LiveNotificationsMount />
                    {<>{children}</>}
                    <Toast />
                    <BottomBar setHasBottomBar={setHasBottomBar} isCurtainRaiserShown={isCurtainRaiserShown} />
                </TableContext.Provider>
            </BottomBarProvider>
        </>
    );
};

export default QrLayout;
